export const createInitialLiveCaptionsState = () => ({
  finalCaptions: [],
  partialCaptionsByStream: {},
  nextFinalCaptionId: 0,
});

const withoutPartialCaption = (partialCaptionsByStream, streamId) => {
  const remaining = { ...partialCaptionsByStream };
  delete remaining[streamId];
  return remaining;
};

export const liveCaptionsReducer = (state, action) => {
  switch (action.type) {
    case 'captionReceived': {
      const { streamId, caption, isFinal, speaker } = action.payload;

      if (!isFinal) {
        return {
          ...state,
          partialCaptionsByStream: {
            ...state.partialCaptionsByStream,
            [streamId]: {
              id: `partial:${streamId}`,
              streamId,
              text: caption,
              speaker,
            },
          },
        };
      }

      const partialCaptionsByStream = withoutPartialCaption(
        state.partialCaptionsByStream,
        streamId,
      );
      if (!caption) return { ...state, partialCaptionsByStream };

      return {
        finalCaptions: [
          ...state.finalCaptions,
          {
            id: `final:${state.nextFinalCaptionId}`,
            streamId,
            text: caption,
            speaker,
          },
        ],
        partialCaptionsByStream,
        nextFinalCaptionId: state.nextFinalCaptionId + 1,
      };
    }
    case 'streamDestroyed':
      return {
        ...state,
        partialCaptionsByStream: withoutPartialCaption(
          state.partialCaptionsByStream,
          action.streamId,
        ),
      };
    case 'captionsDisabled':
      return { ...state, partialCaptionsByStream: {} };
    default:
      return state;
  }
};
